"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentPostRequestInfo = void 0;
var React = require("react");
var DocumentPostRequestInfo = /** @class */ (function (_super) {
    __extends(DocumentPostRequestInfo, _super);
    function DocumentPostRequestInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentPostRequestInfo.prototype.render = function () {
        return (React.createElement("div", { className: "green-card inner-content margin-top-50 document-post-request" },
            React.createElement("p", { className: "document-post-title" },
                React.createElement("h2", { className: "pt-4" }, "Want documents by post?")),
            React.createElement("p", { className: "document-post-text" }, "In order to reduce our carbon footprint and help the planet, all policy documents are online."),
            React.createElement("p", { className: "document-post-text" }, "All the documents are stored securely in your online account."),
            React.createElement("p", { className: "document-post-text" }, "If you'd still like to receive your documents by post you can request them after payment by clicking 'Documents' in your online account.")));
    };
    return DocumentPostRequestInfo;
}(React.Component));
exports.DocumentPostRequestInfo = DocumentPostRequestInfo;
//# sourceMappingURL=DocumentPostRequestInfo.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/motorCommon/DocumentPostRequestInfo.js
// module id = 3450
// module chunks = 0